/**
 * 直播在线人数：后台只给区间 online_min / online_max，前端自行随机取值并周期性跳动。
 * 封顶角标文案另用 ui.online_count_cap_text（如 "99+"）。
 */

function toInt(value) {
  if (value === "" || value == null) {
    return null;
  }
  const n = Number(value);
  return Number.isFinite(n) ? Math.floor(n) : null;
}

export function resolveOnlineCountRange(source = {}, fallbackMin, fallbackMax) {
  const src = source || {};
  let min = toInt(
    src.online_min ?? src.onlineMin ?? src.online_count_min ?? src.live_online_min
  );
  let max = toInt(
    src.online_max ?? src.onlineMax ?? src.online_count_max ?? src.live_online_max
  );

  if (min == null) min = toInt(fallbackMin);
  if (max == null) max = toInt(fallbackMax);

  if (min == null && max == null) {
    return null;
  }
  if (min == null) min = max;
  if (max == null) max = min;
  if (min > max) {
    const tmp = min;
    min = max;
    max = tmp;
  }
  min = Math.max(0, min);
  max = Math.max(min, max);
  return { min, max };
}

/** 在区间内前端自行随机一个整数（含端点） */
export function randomOnlineCount(source, fallbackMin, fallbackMax) {
  const range = resolveOnlineCountRange(source, fallbackMin, fallbackMax);
  if (!range) {
    return "";
  }
  const { min, max } = range;
  if (min === max) {
    return String(min);
  }
  return String(min + Math.floor(Math.random() * (max - min + 1)));
}

export function resolveOnlineCapText(ui = {}, fallback = "99+") {
  const raw = ui && ui.online_count_cap_text;
  if (raw == null || String(raw).trim() === "") {
    return fallback;
  }
  return String(raw).trim();
}
